import React from "react";
import {Box,Button,Dialog,DialogActions,DialogContent,DialogTitle,Divider,IconButton,Typography,} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { ResultadoValidacionPixeles } from "../reglasImagenes/reglasPixelesImagenes";

// PROPS
interface ModalErroresImagenesProps {
  open: boolean;
  onClose: () => void;
  resultado: ResultadoValidacionPixeles | null;
}

// COMPONENTE

const ModalErroresImagenes: React.FC<ModalErroresImagenesProps> = ({
  open,
  onClose,
  resultado,
}) => {

  if (!resultado) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >

      {/*ENCABEZADO*/}

      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <WarningAmberIcon color="warning" />

          <Typography
            variant="h6"
            component="span"
            fontWeight={600}
          >
            {resultado.titulo || "Imagen no válida"}
          </Typography>
        </Box>

        <IconButton
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>


      <Divider />


      {/*CONTENIDO*/}

      <DialogContent>

        <Typography
          variant="body1"
          sx={{ mb: 3 }}
        >
          {resultado.mensaje}
        </Typography>


        {/*COMPARACIÓN DE DIMENSIONES*/}

        {resultado.anchoImagen !== undefined &&
          resultado.altoImagen !== undefined &&
          resultado.anchoRequerido !== undefined &&
          resultado.altoRequerido !== undefined && (

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >

              {/* IMAGEN SELECCIONADA */}

              <Box
                sx={{
                  p: 2,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  Dimensiones de la imagen seleccionada
                </Typography>

                <Typography
                  variant="h6"
                  fontWeight={600}
                >
                  {resultado.anchoImagen}
                  {" x "}
                  {resultado.altoImagen}
                  px
                </Typography>
              </Box>


              {/* DIMENSIONES REQUERIDAS */}

              <Box
                sx={{
                  p: 2,
                  border: "1px solid",
                  borderColor: "error.main",
                  borderRadius: 1,
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  Dimensiones requeridas
                </Typography>

                <Typography
                  variant="h6"
                  fontWeight={600}
                  color="error.main"
                >
                  {resultado.anchoRequerido}
                  {" x "}
                  {resultado.altoRequerido}
                  px
                </Typography>
              </Box>

            </Box>
          )}


        {/* MENSAJE DE AYUDA*/}

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 3 }}
        >
          Selecciona un archivo que tenga exactamente las
          dimensiones requeridas para este tipo de banner.
        </Typography>

      </DialogContent>


      <Divider />


      {/*ACCIONES*/}

      <DialogActions sx={{ p: 2 }}>

        <Button
          variant="contained"
          color="secondary"
          onClick={onClose}
        >
          Entendido
        </Button>

      </DialogActions>

    </Dialog>
  );
};

export default ModalErroresImagenes;